import React from 'react'
import Navbar from './Navbar'
import '../projects.css'

class Projects extends React.Component{

    componentDidMount (){
        console.log("Hello")
    }


    render(){
        return (
            <div className="project-main">
                <Navbar/>
                <div id="home">
                    <section className="heading-proj">
                        Some spicy eSpice internal projects <span role="img" aria-label="ok">👌</span>
                    </section>

                    <div class="horizontalCard">
                        <div class="photo1 left"><h2 class="photoLeftH2"><a href="#">DETOX</a></h2></div>
                        <div class="text1 right">
                                <ul class="ulcardsRight">
                                    <li class="project-heading">DETOX</li>
                                    <li class="project-desc">An app & chrome extension to help you find time for family during the work-heavy lockdown</li>
                                    <li class="project-links"> <a href="https://github.com/ArghyaShubhshiv/Detox">Github Repo</a></li>
                                    <li class="project-links">See Project Page</li>
                                </ul>
                        </div>
                        </div>
                        
                        <div class="horizontalCard">
                        <div class="photo2 right"><h2 class="photoRighttH2body"><a href="#">AIRONA</a></h2></div>
                        <div class="text2 left">
                                <ul class="ulcardsRight">
                                    <li class="project-heading">AIRONA</li>
                                    <li class="project-desc">Chat system where crew and passengers can have a safe and contact less communication and be as safe as possible.</li>
                                    <li class="project-links">See project page</li>
                                    <li class="project-links">Github Repo</li>
                                </ul>
                        </div>
                        </div>
                        
                        <div class="horizontalCard">
                        <div class="photo3 left"><h2 class="photoLeftH2spec"><a href="#">AIRONA</a></h2></div>
                        <div class="text3 right">
                                <ul class="ulcardsRight">
                                    <li class="project-heading">AIRONA</li>
                                    <li class="project-desc">Chat system where crew and passengers can have a safe and contact less communication and be as safe as possible.</li>
                                    <li class="project-links">See project page</li>
                                    <li class="project-links">Github Repo</li>
                                </ul>
                        </div>
                        </div>
                        
                        <div class="horizontalCard">
                        <div class="photo4 right"><h2 class="photoRighttH2"><a href="#">AIRONA</a></h2></div>
                        <div class="text4 left">
                                <ul class="ulcardsRight">
                                    <li class="project-heading">AIRONA</li>
                                    <li class="project-desc">Chat system where crew and passengers can have a safe and contact less communication and be as safe as possible.</li>
                                    <li class="project-links">See project page</li>
                                    <li class="project-links">Github Repo</li>
                                </ul>
                        </div>
                        </div>
                        </div>
                </div>
        )
    }
}

export default Projects